module.exports = __webpack_public_path__ + "img/complete.3f41b21.svg";